<template>
  <NavBar />
  <main>
    <router-view />
  </main>
  <FooterSection />
</template>

<script setup>
import NavBar from '@/components/NavBar.vue'
import FooterSection from '@/components/FooterSection.vue'
</script>
